import { Button, Space } from 'antd';
import { PlusOutlined, QrcodeOutlined } from '@ant-design/icons';
import { ListHeader } from 'containers';
import { useDispatch } from 'react-redux';
import { globalActions } from 'app/services/global';
import { useGenerateQrCodesMutation } from 'app/services/tools';
import { Drawers } from 'app/types/drawer';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Paths, User } from 'constants/index';
import { useHasPermission } from 'hooks/authorization/useHasPermission';
import { useState } from 'react';
import GenerateQrModal from 'components/GenerateQrModal/GenerateQrModal';
import { buildToolQrUrl } from 'utils/qr/parseQrValue';

const TableHeader = () => {
  const { t } = useTranslation();
  const canAddTool = useHasPermission(User.Permissions.ADD_TOOL);

  const dispatch = useDispatch();
  const handleClick = () => dispatch(globalActions.openDrawer({ key: Drawers.ADD_TOOL }));

  const [ isQrModalOpen, setIsQrModalOpen ] = useState(false);
  const [ generateQrCodes ] = useGenerateQrCodesMutation();

  const { pathname } = useLocation();
  const showActive = pathname.includes(Paths.TOOLS_ACTIVE);
  if (!canAddTool) return null;

  return (
    <ListHeader title={t('entities.tools.title')}>
      {showActive && <Space>
        <Button onClick={() => setIsQrModalOpen(true)} icon={<QrcodeOutlined />}>
          {t('components.generateqr.title')}
        </Button>
        <Button onClick={handleClick} icon={<PlusOutlined />} type='primary'>
          {t('common.add', { type: t('entities.tools.title').toLowerCase() })}
        </Button>
      </Space>}
      {showActive && (
        <GenerateQrModal
          open={isQrModalOpen}
          onClose={() => setIsQrModalOpen(false)}
          generateCodes={(count) => generateQrCodes(count).unwrap()}
          buildUrl={buildToolQrUrl}
          fileNamePrefix="kvalilog-tool-qr"
        />
      )}
    </ListHeader>
  );
};

export default TableHeader;
